export class SiteSearchQuery {
  servIsId?: string;
  servIsOwnerId?: string;
  servIsOwnerName?: string;
  customerId?: string;
  customerName?: string;
  name?: string;
  country?: string;
  region?: string;
  city?: string;
  start?: number;
  limit?: number;
  searchInServIs?: boolean;
}
